import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

// OnOffSwitch forwards the className to its inner toggle element, not to the label spans.
// Wrapping it lets us reach the label spans to override their font.
export const StyledOnOffSwitchGroup = styled.div`
    & > div > span {
        ${setFontVariant("listSectionTitle", colorsPalettes.carbon[400])};
    }
`;
